export const ROLES = [
    { id: 'national_head', label: 'National Head', level: 1 },
    { id: 'zone_head', label: 'Zone Head', level: 2 },
    { id: 'state_head', label: 'State Head', level: 3 },
    { id: 'middle_manager', label: 'Team Leader', level: 4 },
    { id: 'manager', label: 'Frontline', level: 5 }
];

const ALLOWED_EMAIL_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'icloud.com',
    'zoho.com',
    'acemoney.in',
    'acemoney.com'
];

export const VALIDATORS = {
    name: (v) => (/^[A-Za-z\s]+$/.test(v) && v.trim().length > 1 ? '' : 'Name must contain only letters (min 2 chars)'),
    email: (v) => {
        if (!v) return 'Email is required';
        const emailRegex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
        const match = v.match(emailRegex);
        if (!match) return 'Enter a valid email address';
        const domain = match[1].toLowerCase();
        if (!ALLOWED_EMAIL_DOMAINS.includes(domain)) {
            return `Only valid domains like gmail.com, yahoo.com, etc. are allowed`;
        }
        return '';
    },
    phone: (v) => (/^\d{10}$/.test(v) ? '' : 'Enter a valid 10-digit phone number'),
    pancard: (v) => (/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) ? '' : 'Enter a valid PAN (e.g. ABCDE1234F)'),
    state: (v) => (v ? '' : 'Please select a state'),
    district: (v) => (v ? '' : 'Please select a district'),
    city: (v) => (v ? '' : 'Please select a city'),
    role: (v) => (v ? '' : 'Please select a role'),
    bgvStatus: (v) => (v ? '' : 'Please select BGV status'),
    trainingStatus: (v) => (v ? '' : 'Please select training status')
};

export const INITIAL_FORM = {
    name: '',
    email: '',
    phone: '',
    pancard: '',
    state: '',
    district: '',
    city: '',
    role: '',
    l1Lead: '',
    dateOfOffer: '',
    dateOfJoining: '',
    bgvStatus: '',
    trainingStatus: '',
    effectiveDate: '',
    photograph: null,
    photographName: '',
    photographPreview: null,
    poaImage: null,
    poaImageName: '',
    poaImagePreview: null
};
